import React from "react";
import { View } from "react-native";
import Skeletons from "./Skeletons";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";

const PastEventDetailSkeleton = ({ styles }) => {
  const deviceSize = useDeviceSize();

  return (
    <View
      style={[
        styles.deviceflexDirection,
        { justifyContent: "space-between", margin: 5 },
      ]}
    >
      <View style={{ flexDirection: "row" }}>
        <View>
          <Skeletons
            height={15}
            width={"200px"}
            style={{
              borderRadius: 10,
              marginBottom: 10,
            }}
          />

          <Skeletons
            height={40}
            width={"200px"}
            style={{
              borderRadius: 10,
              marginBottom: 10,
            }}
          />
        </View>
        <View style={{ marginLeft: 20 }}>
          <Skeletons
            height={15}
            width={"150px"}
            style={{
              borderRadius: 10,
              marginBottom: 10,
            }}
          />
          <View
            style={[
              {
                alignItems: "center",

                flexDirection: "row",
                gap: 10,
              },
            ]}
          >
            <Skeletons
              height={50}
              width={"81px"}
              style={{
                borderRadius: 10,
                marginBottom: 10,
              }}
            />
            <Skeletons
              height={15}
              width={"75px"}
              style={{
                borderRadius: 10,
                marginBottom: 10,
              }}
            />
          </View>
        </View>
      </View>
      <View
        style={{
          flexDirection: "row",
          justifyContent:
            deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
              ? "center"
              : "flex-start",
          alignItems: "center",
          gap: 20,
        }}
      >
        <Skeletons
          height={30}
          width={"200px"}
          style={{
            borderRadius: 10,
            marginBottom: 10,
          }}
        />
        <Skeletons
          height={30}
          width={"100px"}
          style={{
            borderRadius: 10,
            marginBottom: 10,
          }}
        />
      </View>
    </View>
  );
};

export default PastEventDetailSkeleton;
